class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
document.addEventListener('click', async (e) => {
  const upsellArea = e.target.closest('[data-upsells]');
  const btn = e.target.closest('.upsell-atc');
  if (!upsellArea || !btn) return;

  if (btn.dataset.busy === '1') return;      // <-- guard
  btn.dataset.busy = '1';                    // <-- set guard

  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

// --- find a variant id from the upsell form or button ---
const form = btn.closest('form');
let variantId = null;

// from <select name="id"> or <input name="id">
if (form) {
  const fd = new FormData(form);
  variantId = fd.get('id');
}

// fallback to data attributes on the button
if (!variantId) variantId = btn.dataset.variantId || btn.dataset.defaultId;

// if still none, prompt the user and bail
if (!variantId) {
  btn.textContent = 'Select option';
  setTimeout(() => (btn.textContent = 'Add to cart'), 1200);
  btn.disabled = false;
  delete btn.dataset.busy;
  return;
}

// optional: selling plan if your upsell form has one
let sellingPlanId = null;
if (form) {
  const fd2 = new FormData(form);
  sellingPlanId = fd2.get('selling_plan');
}
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    const payload = { id: String(variantId), quantity: 1 };
    if (sellingPlanId) payload.selling_plan = String(sellingPlanId);
    const add = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    });
    if (!add.ok) throw new Error(await add.text());

    // refresh UI (keep your existing refresh code here)

    btn.textContent = 'Added!';
    setTimeout(() => (btn.textContent = original), 1200);
  } catch (err) {
    console.error('Upsell add error:', err);
    btn.textContent = 'Error';
    setTimeout(() => (btn.textContent = original), 1500);
  } finally {
    btn.disabled = false;
    delete btn.dataset.busy;                 // <-- release guard
  }
});
// ===== Upsell Add-to-Cart (AJAX, no redirect) =====
document.addEventListener('click', async (e) => {
  // Only run for clicks inside the upsell area and on upsell buttons
  const upsellArea = e.target.closest('[data-upsells]');
  const btn = e.target.closest('.upsell-atc');
  if (!upsellArea || !btn) return;


  // Block form submission + any parent handlers (prevents navigation)
  e.preventDefault();
  e.stopPropagation();
  if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

  // 1) Get a variant id (from select/hidden OR button data)
  const form = btn.closest('form');
  let variantId = null;
  if (form) {
    const fd = new FormData(form);
    variantId = fd.get('id'); // select/hidden/radio named "id"
  }
  if (!variantId) variantId = btn.dataset.variantId || btn.dataset.defaultId;
  if (!variantId) { btn.textContent = 'Select option'; setTimeout(()=>btn.textContent='Add to cart',1200); return; }
  variantId = String(variantId).trim();

  // Optional: selling plan support (ignored if not present)
  let sellingPlanId = null;
  if (form) {
    const fd = new FormData(form);
    sellingPlanId = fd.get('selling_plan');
  }

  // 2) UI feedback
  const original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';

  try {
    // 3) Add the item (ID must be sent as STRING)
    const payload = { id: variantId, quantity: 1 };
    if (sellingPlanId) payload.selling_plan = String(sellingPlanId);

    const add = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });
    if (!add.ok) {
      const msg = await add.text();
      throw new Error(msg || 'Add failed');
    }

    // 4) Refresh the drawer contents (Dawn + clones)
    const tryRenderContents = async () => {
  const drawer = document.querySelector('cart-drawer');
  if (drawer && typeof drawer.renderContents === 'function') {
        await drawer.renderContents();
    drawer.open?.();
    return true;
  }
      return false;
    };

    const trySectionsAPI = async () => {
  const handles = ['cart-drawer','cart-drawer-items','cart-icon-bubble'];
  const url = new URL(window.location.href);
  url.searchParams.set('sections', handles.join(','));
      const resp = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' }});
  const data = await resp.json().catch(() => ({}));

  let updated = false;

      const drawer = document.querySelector('cart-drawer') || document.getElementById('CartDrawer');
      if (drawer && data['cart-drawer']) { drawer.innerHTML = data['cart-drawer']; updated = true; }

      const items = document.querySelector('cart-drawer-items');
      if (items && data['cart-drawer-items']) { items.innerHTML = data['cart-drawer-items']; updated = true; }

      const bubble = document.querySelector('[data-cart-count-bubble]') || document.getElementById('cart-icon-bubble');
      if (bubble && data['cart-icon-bubble']) { bubble.innerHTML = data['cart-icon-bubble']; updated = true; }

      (document.querySelector('cart-drawer') || drawer)?.open?.();
  if (updated) document.body.classList.add('overflow-hidden','drawer-open');

  return updated;
    };

    const tryCountOnly = async () => {
      const r = await fetch('/cart.js');
      const cart = await r.json();
      const bubble = document.querySelector('[data-cart-count-bubble] .count');
      if (bubble) bubble.textContent = cart.item_count;
      return true;
    };

    const withTimeout = (p, ms) => Promise.race([ p, new Promise(res => setTimeout(()=>res(false), ms)) ]);

    await withTimeout(tryRenderContents(), 1000) ||
    await withTimeout(trySectionsAPI(), 1400) ||
    await withTimeout(tryCountOnly(), 700);

    btn.textContent = 'Added!';
    setTimeout(() => (btn.textContent = original), 1200);
  } catch (err) {
    console.error('Upsell add error:', err);
    btn.textContent = 'Error';
    setTimeout(() => (btn.textContent = original), 1500);
  } finally {
    btn.disabled = false;
  }
});